// Permisos RBAC de Segmentos, ENCENDIDOS: sin las claves sembradas la pantalla se esconde
// (fail-closed). Eso es lo correcto, no un bug del front.

/**
 * Claves de permiso del dominio. Van como `string` y no como `Permission` porque `PermissionKey`
 * (generado del OpenAPI del rbac) hoy no expone ninguna clave de dominio.
 */
export const SEGMENTS_PERMISSIONS = {
    read: 'loan.segment.read',
    write: 'loan.segment.write',
} as const;

/** El gate está encendido: sin la clave la pantalla se esconde (fail-closed). */
export const SEGMENTS_PERMISSIONS_ENFORCED = true;

export interface SegmentsAbilities {
    canRead: boolean;
    canWrite: boolean;
}

/** Con `enforce: false` todo queda permitido; con `true` cada acción exige su clave. */
export function resolveSegmentsAbilities(
    grantedPermissions: ReadonlySet<string>,
    enforce: boolean = SEGMENTS_PERMISSIONS_ENFORCED,
): SegmentsAbilities {
    if (!enforce) return { canRead: true, canWrite: true };
    return {
        canRead: grantedPermissions.has(SEGMENTS_PERMISSIONS.read),
        canWrite: grantedPermissions.has(SEGMENTS_PERMISSIONS.write),
    };
}
